import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      height: 'auto',
      borderRadius: 4,

      '&:hover': {
        backgroundColor: COLORS.primary.silver,
      },
    },
    selected: {
      backgroundColor: COLORS.primary.light,
    },
  }),
  { name: 'FieldSelectMenuItem' }
);
